/**
 * Returns the Barbados states list to populate the select item.
 */
 export function gluky_addressfield_bb_states_list() {
  let temporalStates = [];
  const states =
  {
    '00': 'Christ Church',
    '01': 'Saint Andrew',
    '02': 'Saint George',
    '03': 'Saint James',
    '04': 'Saint John',
    '05': 'Saint Joseph',
    '06': 'Saint Lucy',
    '07': 'Saint Michael',
    '08': 'Saint Peter',
    '09': 'Saint Philip',
    '10': 'Saint Thomas'
}
  Object.keys(states).map((res) => {
    temporalStates = [
      ...temporalStates,
      {
        name: states[res],
        code: res,
      },
    ];
  });
  return temporalStates;
}

/**
 * Returns the Barbados cities list by state code to populate the select item.
 *
 * @param $state_code
 *   The DANE state code
 * @return
 */
 export function gluky_addressfield_bb_cities_list($state_code) {
  let temporalCities = [];
  const $data = {
    '00': {
        '0001': 'Christ Church'
    },
    '01': {
        '0101': 'Saint Andrew',
    },
    '02': {
        '0201': 'Saint George',
    },
    '03': {
        '0301': 'Saint James',
    },
    '04': {
        '0401': 'Saint John',
    },
    '05': {
        '0501': 'Saint Joseph',
    },
    '06': {
        '0601': 'Saint Lucy',
    },
    '07': {
        '0701': 'Saint Michael',
    },
    '08': {
        '0801': 'Saint Peter',
    },
    '09': {
        '0901': 'Saint Philip',
    },
    '10': {
        '1001': 'Saint Thomas'
    }
  }
  const cities = $data[$state_code] ? $data[$state_code] : null;
  Object.keys(cities).map((citie) => {
    temporalCities = [
      ...temporalCities,
      {
        name: cities[citie],
        code: citie,
      },
    ];
  });
  return temporalCities;
}

